import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClose", "onEnrich", "propertyName", "selectionCrmSearchQuery"];
import { useState } from 'react';
import { SmartFillModalContent } from './SmartFillModalContent';
import { SmartFillModalContextProvider } from './useSmartFillModal/SmartFillModalContextProvider';
import { ModalBulkProvider } from '../../ModalBulk/ModalBulkProvider';
import { CRMSearchProvider } from '../../CRMSearchProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const SmartFillModal = _ref => {
  let {
      onClose,
      onEnrich,
      propertyName,
      selectionCrmSearchQuery
    } = _ref,
    batchActionProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isOpen, setIsOpen] = useState(true);
  const handleClose = () => {
    setIsOpen(false);
  };
  const handleCloseComplete = () => {
    onClose === null || onClose === void 0 || onClose();
  };
  return /*#__PURE__*/_jsx(ModalBulkProvider, {
    children: /*#__PURE__*/_jsx(SmartFillModalContextProvider, Object.assign({
      onClose: onClose,
      onEnrich: onEnrich,
      propertyName: propertyName,
      selectionCrmSearchQuery: selectionCrmSearchQuery
    }, batchActionProps, {
      children: /*#__PURE__*/_jsx(CRMSearchProvider, {
        query: selectionCrmSearchQuery,
        selectionMethod: batchActionProps.selectionMethod,
        children: /*#__PURE__*/_jsx(SmartFillModalContent, {
          isOpen: isOpen,
          onClose: handleClose,
          onCloseComplete: handleCloseComplete
        })
      })
    }))
  });
};